<script setup>
import { ref, onMounted } from 'vue'

const loading = ref(true)

const fetchData = async () => {
  loading.value = true
  try {
    // TODO: Add API calls here
    console.log('EntryBoard data loading')
  } catch (err) {
    console.error('Failed to load entry board data', err)
  } finally {
    loading.value = false
  }
}

onMounted(fetchData)
</script>

<template>
  <div class="entry-board-container">
    <v-row class="text-center mb-4">
      <v-col cols="12">
        <h1 class="title font-weight-bold">CFES Admin Tool</h1>
        <div class="headline-border"></div>
      </v-col>
    </v-row>

    <template v-if="loading">
      <div class="loader-container">
        <v-progress-circular indeterminate :size="120" :width="8" color="primary">
          loading
        </v-progress-circular>
      </div>
    </template>

    <template v-else>
      <v-row class="section-grid" dense>
        <v-col cols="12">
          <v-card class="section-card">
            <v-card-title>CFES Admin Tool</v-card-title>
            <v-card-text>
              <!-- TODO: Add your content here -->
              <p>Welcome to CFES Admin Tool</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<style scoped>
.entry-board-container {
  width: 100%;
  padding: 4px;
}

.title {
  font-size: 1.1rem;
}

.headline-border {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #4f46e5, #06b6d4);
  margin: 12px auto 0;
  border-radius: 999px;
}

.section-card {
  padding: 10px 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.05);
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 0;
}

.section-grid {
  row-gap: 8px;
}
</style>
